import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Chat from './components/Chat';
import AdminLogin from './components/AdminLogin';
import NotFound from './components/NotFound';
import { initializeCSRFToken } from './utils/axiosConfig';

/**
 * App Component
 *
 * Main application component with URL-based routing.
 * Routes:
 *   / - Home page (public)
 *   /chat - Chat interface (public)
 *   /admin - Admin portal (internal only, protected by WAF)
 *   * - 404 Not Found
 *
 * Returns:
 *     JSX: Application with routing
 */
function App() {
  // Initialize CSRF token on app load if enabled
  useEffect(() => {
    const csrfEnabled = process.env.REACT_APP_CSRF_ENABLED === 'true';
    if (csrfEnabled) {
      initializeCSRFToken().catch(error => {
        console.error('Failed to initialize security:', error);
      });
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;